<template>
  <CSidebar class="sidebar" :minimize="minimize" unfoldable :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
    <div class="logo">
      <CSidebarBrand class="d-md-down-none" :to="user.rolename== 'client' ? '/clientboard' : '/'">
        <div class="logo-img">
          <b-img class src="/img/brand/logo_trans.png"></b-img>
        </div>

        <span class="logo-text c-sidebar-brand-full logo-normal brand">
          <div class="name">TRAVEL PLACES</div>
          <div class="highlight">TEAM TRAVEL SPECIALISTS</div>
        </span>
      </CSidebarBrand>
    </div>

    <div class="sidebar_type" :class="compress == true
      ? 'menu_compress'
      : ''
      ">

      <b-link id="menu_height" size="sm" class="text-primary menu_height" @click="compress = !compress">
        <i :class="compress == true
          ? 'fa fa-expand'
          : 'fa fa-compress'
          "></i>
      </b-link>
      <b-tooltip target="menu_height" placement="bottom">Compress/expand menu height</b-tooltip>

      <!-- <CSidebarNavTitle>GENERAL</CSidebarNavTitle> -->
      <!-- v-if="user.permissions.includes('/dashboard')" -->
      <li class="ml-2 small text-secondary">Queues</li>

      <div class="badgecontainer">
        <CSidebarNavItem fontIcon="fa fa-bell" to="/notifications" name="Notifications"></CSidebarNavItem>
        <CBadge shape="pill" color="primary" v-if="$store.state.notifications.length > 0">{{
          $store.state.notifications.length }}</CBadge>
      </div>

      <!-- <div class="badgecontainer" v-if="permissionvalid('systems.development')">
        <CSidebarNavItem fontIcon="fa fa-credit-card" to="/bookings" name="New Bookings"></CSidebarNavItem>
        <CBadge shape="pill" color="danger" v-if="$store.state.bookings.length > 0">{{ $store.state.bookings.length }}
        </CBadge>
      </div> -->


      <!-- <div class="badgecontainer" v-if="permissionvalid('systems.development')">
        <CSidebarNavItem fontIcon="fa fa-tasks" to="/bookingforms" name="Booking Forms (old)"></CSidebarNavItem>
        <CBadge shape="pill" color="danger" v-if="$store.state.bookingforms.length > 0">{{
    $store.state.bookingforms.length
  }}
        </CBadge>
      </div> -->


      <!-- <div class="badgecontainer" v-if="permissionvalid('bookingforms.admin')">
        <CSidebarNavItem fontIcon="fa fa-stack-overflow" to="/inventory" name="Inventory"></CSidebarNavItem>
        <CBadge shape="pill" color="danger" v-if="$store.state.inventory.length > 0">{{ $store.state.inventory.length }}
        </CBadge>
      </div>

      <div class="badgecontainer" v-if="permissionvalid('systems.development')">
        <CSidebarNavItem fontIcon="fa fa-stack-exchange" to="/conferma" name="Conferma"></CSidebarNavItem>
        <CBadge shape="pill" color="purple" v-if="$store.state.conferma.length > 0">{{ $store.state.conferma.length }}
        </CBadge>
      </div>

      <div class="badgecontainer" v-if="permissionvalid('systems.development')">
        <CSidebarNavItem fontIcon="fa fa-stack-exchange" to="/zhold" name="Zhold"></CSidebarNavItem>
        <CBadge shape="pill" color="orange" v-if="$store.state.zhold.length > 0">{{ $store.state.zhold.length }}
        </CBadge>
      </div> -->


      <div class="badgecontainer">
        <CSidebarNavItem fontIcon="fa fa-paper-plane" to="/invoicing" name="Invoicing"></CSidebarNavItem>
        <CBadge v-if="$store.state.invoicing" shape="pill" color="success">On</CBadge>
        <CBadge v-if="!$store.state.invoicing" shape="pill" color="danger">Off</CBadge>
        <!-- <CBadge shape="pill" color="danger" v-if="$store.state.inventory.length > 0">{{ $store.state.inventory.length }}
        </CBadge> -->
      </div>

      <div class="badgecontainer" v-if="permissionvalid('bookingforms.view')">
        <CSidebarNavItem fontIcon="fa fa-tasks" to="/bookingforms2" name="Booking Forms"></CSidebarNavItem>
        <CBadge shape="pill" color="danger" v-if="$store.state.bookingforms.length > 0">{{
          $store.state.bookingforms.length
        }}
        </CBadge>
      </div>


      <!-- <div class="badgecontainer" v-if="permissionvalid('queue.view')">
        <CSidebarNavItem fontIcon="fa fa-stack-overflow" to="/queued" name="Queued"></CSidebarNavItem>
        <CBadge shape="pill" color="warning" v-if="$store.state.queued.length > 0">{{ $store.state.queued.length }}
        </CBadge>
      </div> -->

      <div class="badgecontainer" v-if="permissionvalid('pnrlibrary.view')">
        <CSidebarNavItem fontIcon="fa fa-book" to="/pnrs" name="PNRs"></CSidebarNavItem>
        <CBadge shape="pill" color="white" v-if="$store.state.pnrs.length > 0">{{ $store.state.pnrs.length }}
        </CBadge>
      </div>

      <div class="badgecontainer" v-if="permissionvalid('documents.view')">
        <CSidebarNavItem fontIcon="fa fa-folder-open" to="/documents" name="Documents"></CSidebarNavItem>
        <CBadge shape="pill" color="info" v-if="$store.state.documents.length > 0">{{ $store.state.documents.length }}
        </CBadge>
      </div>
      <!-- v-if="permissionvalid('notifications.view') -->

      <li class="ml-2 small text-secondary">My Apps</li>
      <!-- <CSidebarNavTitle>MY APPS</CSidebarNavTitle> -->
      <CSidebarNavItem v-if="permissionvalid('navigation.dashboard')" icon="cil-speedometer"
        :to="user.rolename== 'client' ? '/clientboard' : '/'" name="Dashboard"></CSidebarNavItem>

      <CSidebarNavItem v-if="permissionvalid('navigation.accounts')" fontIcon="fa fa-balance-scale" to="/apps/Accounts"
        name="Accounts"></CSidebarNavItem>

      <CSidebarNavItem v-if="permissionvalid('orders.view')" fontIcon="fa fa-gavel" to="/Orders" name="Orders">
      </CSidebarNavItem>


      <div class="badgecontainer">
        <CSidebarNavItem fontIcon="fa fa-puzzle-piece" to="/inventorylines" name="Charges"></CSidebarNavItem>
      </div>

      <div class="badgecontainer" v-if="permissionvalid('charters.view')">
        <CSidebarNavItem fontIcon="fa fa-fighter-jet" to="/charters" name="Charters"></CSidebarNavItem>
      </div>
      <div class="badgecontainer" v-if="permissionvalid('tickets.view')">
        <CSidebarNavItem fontIcon="fa fa-ticket" to="/tickets" name="Tickets"></CSidebarNavItem>
      </div>

      <div class="badgecontainer" v-if="permissionvalid('salesledger.view')">
        <CSidebarNavItem fontIcon="fa fa-wpforms" to="/Invoices" name="Sales ( Invoices )"></CSidebarNavItem>
      </div>

      <!-- <CSidebarNavItem v-if="permissionvalid('navigation.flights')" fontIcon="fa fa-plane mt-1" to="/apps/Flights"
        name="Flights"></CSidebarNavItem>
      <CSidebarNavItem v-if="permissionvalid('navigation.hotels')" fontIcon="fa fa-hotel mt-1" to="/apps/Hotels"
        name="Hotels"></CSidebarNavItem>
      <CSidebarNavItem v-if="permissionvalid('navigation.cars')" fontIcon="fa fa-car mt-1" to="/apps/Cars" name="Cars">
      </CSidebarNavItem> -->

      <!-- <CSidebarNavItem fontIcon="fa fa-leanpub mt-1" to="/apps/Reportso" name="Reports"></CSidebarNavItem> -->
      <CSidebarNavItem fontIcon="fa fa-leanpub mt-1" to="/apps/Reports" name="Reports"></CSidebarNavItem>
      
      <CSidebarNavItem fontIcon="fa fa-cogs mt-1" to="/Setup" name="Setup"></CSidebarNavItem>

      <!-- <CSidebarNavItem v-if="permissionvalid('navigation.systems')" fontIcon="fa fa-heartbeat mt-1" to="/apps/Systems"
      name="Systems"></CSidebarNavItem> -->

      <!-- <CSidebarNavItem v-if="permissionvalid('navigation.ourpartners')" fontIcon="fa fa-cloud-upload mt-1"
      to="/apps/Partners" name="Our Partners"></CSidebarNavItem> -->

      <div class="badgecontainer" v-if="permissionvalid('navigation.ourpartners')">
        <CSidebarNavItem fontIcon="fa fa-free-code-camp" to="/apps/CarbonEmissions" name="Carbon Emissions">
        </CSidebarNavItem>
      </div>

      <!-- <div class="badgecontainer" v-if="permissionvalid('navigation.ouremissions')"> -->
        <CSidebarNavItem fontIcon="fa fa-envira" to="/apps/OurEmissions" name="Our Emissions"></CSidebarNavItem>
      <!-- </div> -->


      <!-- <CSidebarNavDivider class="m-0"></CSidebarNavDivider>

    <li class="c-sidebar-nav-item" v-if="permissionvalid('navigation.help')">
      <a v-if="this.user && this.user.rolename!= 'client'" href="https://travelplaces.stoplight.io/docs/backoffice"
        class="c-sidebar-nav-link" target="_blank"><i class="c-sidebar-nav-icon fa fa-question-circle mt-1"></i>
        Help
      </a>
      <a v-if="this.user && this.user.rolename== 'client'" href="https://travelplaces.stoplight.io/docs/eclient"
        class="c-sidebar-nav-link" target="_blank"><i class="c-sidebar-nav-icon fa fa-question-circle mt-1"></i>
        Help
      </a>
    </li> -->

      <CSidebarNavDivider class="m-0"></CSidebarNavDivider>

      <CSidebarNavItem fontIcon="fa fa-power-off" to="/logout" name="Logout"></CSidebarNavItem>
    </div>
    <CSidebarMinimizer class="c-d-md-down-none" @click.native="$store.commit('toggle', 'sidebarMinimize')" />
    <b-card v-if="user.rolename== 'client'" no-body class="m-2 sidebar-info">
      <b-card-header class="m-0 text-primary"><i class="fa fa-2x fa-info-circle inline pr-2 pt-1"></i>
        <h3>Please Note</h3>
      </b-card-header>
      <b-card-body><span>
          Form of payment determines timeliness of invoice and accuracy of
          spend.</span>
      </b-card-body>
    </b-card>

  </CSidebar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheSidebar",
  data() {
    return {
      compress: false
    };

  },
  computed: {
    ...mapGetters(["user"]),
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>
